__turbopack_context__.v({
  "characteristics": "_25vzna_characteristics",
  "gallery": "_25vzna_gallery",
  "heading": "_25vzna_heading",
  "imageButton": "_25vzna_imageButton" + " " + __turbopack_context__.i(248112)["focusOutline"],
});
